import React from 'react';
import cx from 'classnames';
import styles from './GameTypeTabs.module.scss';

export const GameTypeTabs = ({ tabs, activeKey, onChange }) => (
  <div className={styles.wrapper}>
    <div className={styles.inner}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={cx(styles.tab, tab.key === activeKey && styles.tabActive)}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  </div>
);
